/**
 * True only for the Steam Electron build (REACT_APP_DISTRIBUTION=steam).
 * Regular website and direct-download Electron builds must stay false.
 */
export function isSteamClient() {
  return process.env.REACT_APP_DISTRIBUTION === 'steam';
}

export default isSteamClient;
